export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';
export const FETCH_DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_FAIL = 'FETCH_DEPARTMENTS_FAIL';

export const fetchDepartments = () => ({
  type: FETCH_DEPARTMENTS
});

export const fetchDepartmentsSuccess = (departments) => ({
  type: FETCH_DEPARTMENTS_SUCCESS,
  payload: departments
});

export const fetchDepartmentsFail = () => ({
  type: FETCH_DEPARTMENTS_FAIL
});
